import React, { useEffect } from "react";
import Solutio from "../components/sections/Solutio";
import FinalCTA from "../components/sections/FinalCTA";
import useSEO from "../hooks/useSEO";
import { useLang } from "../context/LanguageContext";

export default function SolutioPage() {
  const { lang } = useLang();
  useSEO({
    title: lang === "pl" ? "Solutio — Obsługa prawna — LK LOG" : "Solutio — Legal support — LK LOG",
    description:
      lang === "pl"
        ? "Kancelaria Solutio w strukturze LK LOG. Obsługa prawna firm, windykacja, restrukturyzacja, ochrona majątku."
        : "Solutio law firm within LK LOG. Legal services, debt recovery, restructuring, asset protection.",
    path: "/solutio",
    lang,
  });
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  return (
    <main data-testid="solutio-page" className="pt-20">
      <Solutio />
      <FinalCTA />
    </main>
  );
}
